import React, { useEffect } from 'react'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { ConfigManager, SITE_TYPE } from '~/managers/ConfigManager'
import PageLoader from '~/components/PageLoader'

import appStore from '~/app/store/store'
import xidrAppStore from '~/xidrApp/store/store'
import bizStore from '~/biz/store/store'
import xidrBizStore from '~/xidrBiz/store/store'

import AppRoot from '~/app/Root'
import XIDRAppRoot from '~/xidrApp/Root'
import BizRoot from '~/biz/Root'
import XIDRBizRoot from '~/xidrBiz/Root'

import SSOManager from '~/managers/SSOManager'
import StraitsXTheme from './StraitsXTheme'

ConfigManager.setupGA()
ConfigManager.setupGTM()

const App = () => {
  useEffect(() => {
    if (!SSOManager.isLogined()) {
      SSOManager.ssoLogin()
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  if (!SSOManager.isLogined()) {
    return <PageLoader />
  }

  const rootComponent = (() => {
    switch (ConfigManager.getSiteType()) {
      case SITE_TYPE.APP:
        return <AppRoot />

      case SITE_TYPE.XIDR_APP:
        return <XIDRAppRoot />

      case SITE_TYPE.BIZ:
        return <BizRoot />

      case SITE_TYPE.XIDR_BIZ:
        return <XIDRBizRoot />
    }
    return null
  })()

  const reduxStore = (() => {
    switch (ConfigManager.getSiteType()) {
      case SITE_TYPE.APP:
        return appStore

      case SITE_TYPE.XIDR_APP:
        return xidrAppStore

      case SITE_TYPE.BIZ:
        return bizStore

      case SITE_TYPE.XIDR_BIZ:
        return xidrBizStore
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return null as any // this for avoid TS to raise type warning
  })()

  return (
    <Provider store={reduxStore}>
      <BrowserRouter>
        <StraitsXTheme>{rootComponent}</StraitsXTheme>
      </BrowserRouter>
    </Provider>
  )
}

export default App
